import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";

//styled components
import themeHandler from "../helpers/themeHandler";
import { ThemeProvider } from "styled-components";
import GlobalStyle from "../styles/GlobalStyle";
// componentes de LOi
import Loading from "./Loading";
//provider
import { Provider } from "react-redux";
import store from "../redux/data";
//componentes
const DetalleProducto = React.lazy(() => import("./detalleProducto"));

const container = document.getElementById("opciones-listas-detalle-producto");

if (container) {
  const root = createRoot(container);

  root.render(
    <Provider store={store}>
      <ThemeProvider theme={themeHandler(window.location.hostname)}>
        <GlobalStyle />
        <Suspense fallback={<Loading elemento="detalle-producto" />}>
          <DetalleProducto />
        </Suspense>
      </ThemeProvider>
    </Provider>
  );
}
